import React, { useState, useEffect } from 'react';
import { AiOutlineArrowUp } from '@react-icons/all-files/ai/AiOutlineArrowUp';

import './ScrollToTopButton.css';

function ScrollToTopButton() {
  const [showButton, setShowButton] = useState(false);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {showButton && (
        <button className="scroll-to-top-button" onClick={handleClick}>
          Top <AiOutlineArrowUp />
        </button>
      )}
    </>
  );
}

export default ScrollToTopButton;
